'use client';

import { useLocale } from 'app/[locale]/hooks/useTranslate';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';
import Image from 'next/image';
import Link from 'next/link';
import { HomePaths, Paths, PathsForExternal } from 'src/modules/Paths';

export function Footer(): JSX.Element {
  const locale = useLocale();
  const { t } = useTranslate();

  return (
    <div className="w-full max-w-homepage flex flex-col md:flex-row justify-center gap-0 md:gap-3 md:pt-[88px] px-8 md:px-10 pb-20 md:pb-[60px] mx-auto border-t border-solid border-gray-soft">
      {locale === 'ja' && (
        <div className="flex flex-col max-w-full md:max-w-[50%] gap-6 md:gap-0 py-8 md:py-0 mr-auto border-b md:border-none border-solid border-gray-soft">
          <Image
            src={'/callabo/homepage/footer_nihonium.svg'}
            className="h-6 md:h-8 mb-0 md:mb-6"
            width={92}
            height={32}
            alt="nihonium logo"
          />
          <div className="flex flex-wrap items-start md:items-center text-center gap-0 md:gap-3 not-italic text-sm md:text-base text-gray-steel max-w-full break-keep">
            {t.common.FOOTER_PAYMENT_COMPANY}
          </div>
          <div className="text-xs md:text-sm md:mt-8 break-keep text-gray-neutral">
            <p
              dangerouslySetInnerHTML={{
                __html: t.common.FOOTER_PAYMENT_COMPANY_ADDRESS,
              }}
            />
            <br />
            <br />
            <span>© Nihonium Inc.</span>
          </div>
        </div>
      )}
      <div className="flex flex-col max-w-full md:max-w-[50%] gap-6 md:gap-0 py-8 md:py-0">
        <div className="flex items-center mb-0 md:mb-6">
          <Image
            src={'/callabo/homepage/footer_logo.svg'}
            className="w-6 h-6 md:w-7 md:h-7 mr-1"
            width={24}
            height={24}
            alt="logo"
          />
          <Image src={'/callabo/logo.svg'} width={101} height={22} alt="logo text" />
        </div>
        <div className="flex flex-col md:flex-row flex-wrap items-start md:items-center text-center gap-1.5 md:gap-3 not-italic text-sm md:text-base text-gray-steel max-w-full break-keep">
          <Link
            href={Paths.TermService}
            target="_blank"
            onMouseDown={() => {
              analyticsInstance.logEvent('click_footer_menu', {
                menu: 'service',
              });
            }}
            dangerouslySetInnerHTML={{ __html: t.common.TERM_SERVICE }}
          />
          <div className="hidden md:block w-[1px] h-4 bg-gray-steel shrink-0" />
          <Link
            href={Paths.TermPrivacy}
            className="font-bold"
            target="_blank"
            onMouseDown={() => {
              analyticsInstance.logEvent('click_footer_menu', {
                menu: 'privacy',
              });
            }}
            dangerouslySetInnerHTML={{ __html: t.common.TERM_PRIVACY }}
          />
          <div className="hidden md:block w-[1px] h-4 bg-gray-steel shrink-0" />
          <Link
            href={HomePaths.Security}
            target="_blank"
            onMouseDown={() => {
              analyticsInstance.logEvent('click_footer_menu', {
                menu: 'security',
              });
            }}
            dangerouslySetInnerHTML={{ __html: t.common.SECURITY }}
          />
          <div className="hidden md:block w-[1px] h-4 bg-gray-steel shrink-0" />
          {locale === 'ja' && (
            <>
              <Link href={Paths.NoticeForStripe} target="_blank">
                {'特定商取引法に基づく表記'}
              </Link>
            </>
          )}
          <div className="flex flex-col md:flex-row flex-wrap items-start md:items-center gap-1.5 md:gap-3 text-sm md:text-base text-gray-steel">
            <Link
              href={PathsForExternal.Blog}
              target="_blank"
              onMouseDown={() => {
                analyticsInstance.logEvent('click_footer_menu', {
                  menu: 'blog',
                });
              }}
              dangerouslySetInnerHTML={{ __html: t.common.BLOG }}
            />
            <div className="hidden md:block w-[1px] h-4 bg-gray-steel shrink-0" />
            <Link
              href={PathsForExternal.LinkedIn}
              target="_blank"
              onMouseDown={() => {
                analyticsInstance.logEvent('click_footer_menu', {
                  menu: 'linkedin',
                });
              }}
              dangerouslySetInnerHTML={{ __html: t.home.FOOTER_LINKED_IN }}
            />
            <div className="hidden md:block w-[1px] h-4 bg-gray-steel shrink-0" />
            <Link
              href={PathsForExternal.RTZR}
              target="_blank"
              onMouseDown={() => {
                analyticsInstance.logEvent('click_footer_menu', {
                  menu: 'rtzr',
                });
              }}
              dangerouslySetInnerHTML={{ __html: t.home.FOOTER_RTZR }}
            />
          </div>
        </div>
        <div className="text-xs md:text-base md:mt-8 break-keep text-gray-neutral flex flex-col gap-4">
          <p dangerouslySetInnerHTML={{ __html: t.common.FOOTER_COMPANY_INFO }} />
          <span>© returnzero Inc.</span>
        </div>
        <div className="flex gap-3 items-center md:mt-6">
          <Image
            src="/callabo/security/ISO_27001_logo_gray.svg"
            alt="ISO logo"
            width={46}
            height={45}
          />
          <div className="text-xs md:text-sm text-gray-neutral">
            <p>{t.security.SECURITY_ISO_CERTIFICATION}</p>
            <p>{t.security.SECURITY_ISO_VALIDITY}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
